<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:98%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
			
				<div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 2vh;"
				
				>	
                    <div style="height: 35px;width:100px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==0?'#3c9cff':'#d9ecff',color:type==0?'white':'#409eff'}" @click="type=0,getmore()"
                    >
                        {{ "全部文章" }}
                    </div>
                    <div style="height: 35px;width:100px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==1?'#3c9cff':'#d9ecff',color:type==1?'white':'#409eff'}" @click="type=1,getmore()"
                    >
                        {{ "待审核文章" }}
                    </div>
				</div>

				<div style="height: auto;flex:1;" >
				<el-table
					height="80vh"
				    :data="list"
					border
				    style="width: 100%"
					>
				    <el-table-column
				      prop="author"
				      label="署名"
				      width="200">
				    </el-table-column>
                    <el-table-column
				      prop="title"
				      label="标题"
				      width="200">
				    </el-table-column>
                    <el-table-column
				      label="封面"
				      width="300">
                        <template slot-scope="scope">
							<img :src="scope.row.cover" referrerpolicy="no-referrer" style="width: 90%;height: 150px;object-fit:cover;"/>
					    </template>
				    </el-table-column>

                    <el-table-column
				  
				       label="文章内容"
				      >
                      <template slot-scope="scope">
                           <div>{{ scope.row.content.length>100?scope.row.content.substring(0,100)+'...':scope.row.content }}</div>
					    </template>
				    </el-table-column>
                    <el-table-column
				      label="B站专栏/动态"
				      width="300"
                      prop="url"
                      >
                       
				    </el-table-column>
					<el-table-column
				      label="状态"
				      width="100">
                        <template slot-scope="scope">
							<div>{{ scope.row.show==0?'待审核':'已通过' }}</div>
					    </template>
				    </el-table-column>
                    <el-table-column
					      fixed="right"
					      label="操作"
						  width="200"
					      >
					      <template slot-scope="scope">
							<el-button @click="deletemessage(scope.row)" type="text" size="small">删除</el-button>
                            <el-button v-if="scope.row.show==0" @click="shenhemessage(scope.row)" type="text" size="small">通过</el-button>
                            <el-button @click="info=scope.row.content,show=true" type="text" size="small">查看全文</el-button>
					      </template>
					</el-table-column>
				  </el-table>
				</div>
			</div>
		</div>
         <el-dialog title="文章详情" :visible.sync="show">
            <div v-html="withNoReferrer(info)"></div>
        </el-dialog>

		
		
		
	</div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
       list:[],
       type:0,
       show:false,
       info:""
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {
    withNoReferrer(html) {
        if (!html) return "";
        return String(html).replace(/<img\b(?![^>]*\breferrerpolicy=)/gi, '<img referrerpolicy="no-referrer"');
    },
	getmore(){
		post("/api/admin/getthemelist",{}).then((res)=>{
			if(res.data.code==1001){
                if(this.type==1){
                    for(var x=0;x<res.data.data.length;x++){
                        if(res.data.data[x].show==1){
                            res.data.data.splice(x,1);
                            x--;
                        }
                    }
                }
                this.list=res.data.data;
            }
		})
	},
    shenhemessage(e){
        post("/api/admin/updatetheme",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    message: res.data.msg,
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    message: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    },
    deletemessage(e){
        post("/api/deletetheme",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    message: res.data.msg,
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    message: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    }
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
